import React from 'react';

const PageNotFound404 = () => (
  <div style={{
    display: 'flex', flexDirection: 'column', alignItems: 'center',
    justifyContent: 'center', minHeight: '60vh', gap: 12,
  }}>
    <div style={{ fontFamily: 'var(--font-mono)', fontSize: 72, fontWeight: 500, color: 'var(--border-strong)', letterSpacing: '-2px' }}>404</div>
    <div style={{ fontFamily: 'var(--font-sans)', fontSize: 16, fontWeight: 500, color: 'var(--ink-700)' }}>Page not found</div>
    <div style={{ fontFamily: 'var(--font-sans)', fontSize: 13, color: 'var(--ink-500)' }}>The page you're looking for doesn't exist.</div>
    <a href="/app/dashboard" style={{ marginTop: 8, fontFamily: 'var(--font-sans)', fontSize: 13, color: 'var(--accent)', textDecoration: 'none', fontWeight: 500 }}>
      ← Back to Dashboard
    </a>
  </div>
);

export default PageNotFound404;
